import React, { useState, useRef, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Constants from "../../Utilities/Constants";
import ChatMessage from "./ChatMessage";
import { AppContext } from "../../Contexts/AppContext";

const WELCOME = { role: "assistant", content: "שלום! אני כאן לעזור לך למצוא מוצרים. מה תרצה?" };

const ChatPanel = () => {
    const { customer } = useContext(AppContext);
    const [messages, setMessages] = useState([WELCOME]);
    const [history, setHistory] = useState([]);
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);
    const bottomRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, loading]);

    const send = async () => {
        const text = input.trim();
        if (!text || loading) return;

        const userMessage = { role: "user", content: text };
        setMessages(prev => [...prev, userMessage]);
        setInput("");
        setLoading(true);

        try {
            const { data } = await axios.post(Constants.API_URL_AI_CHAT, {
                message: text,
                history,
                customerId: customer?.customerId ?? 0
            });

            console.log("AI response:", data);
            setHistory(data.history || []);
            setMessages(prev => [...prev, {
                role: "assistant",
                content: data.content
            }]);

            if (data.products?.length > 0) {
                navigate("/AiResults", { state: { products: data.products, query: text } });
            }
        } catch {
            setMessages(prev => [...prev, {
                role: "assistant",
                content: "מצטער, אירעה שגיאה. אנא נסה שנית."
            }]);
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") send();
    };

    return (
        <div className="chat-panel">
            <div className="chat-panel-header">🛒 עוזר הקניות</div>

            <div className="chat-messages">
                {messages.map((msg, i) => (
                    <ChatMessage key={i} message={msg} />
                ))}
                {loading && <div className="chat-loading">מחפש...</div>}
                <div ref={bottomRef} />
            </div>

            <div className="chat-input-area">
                <button onClick={send} disabled={loading}>➤</button>
                <input
                    type="text"
                    placeholder="חפש מוצר או שאל שאלה..."
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={loading}
                />
            </div>
        </div>
    );
};

export default ChatPanel;
